import { inject, Injectable, signal } from '@angular/core';
import { first, ReplaySubject, tap } from 'rxjs';
import {CmsApiService} from "./api/cms-api.service";
import {CacheControl} from "../types/cache.type"

@Injectable({
  providedIn: 'root'
})
export class CFCacheService {

  private _cmsApi = inject(CmsApiService);

  public cacheControl = signal<CacheControl[]>([]);
  public cacheCanged$ = new ReplaySubject(1);

  /**
   * Loads the cache control data from the CMS API and populates the `cacheControl` map.
   * This method is used to update the cache control information in the service.
   */
  public loadCfCache() {
    return this._cmsApi.getCacheCf().pipe(
      first(),
      tap(e => {
        const data = (e?.data?.cacheControl || []).map(item => ({
          cacheKey: item.cacheKey,
          version: item.version
        }));
        this.cacheControl.set(data);
        this.cacheCanged$.next(true);
      })
    );
  }

  /**
   * Updates the cache control data by loading it from the CMS API.
   * This method is used to refresh the cache control information in the service.
   */
  public updateCache$() {
    return this.loadCfCache().pipe(
      first(),
      tap(() => {
        this.cacheCanged$.next(true);
      })
    );
  }

}
